module.exports = __webpack_public_path__ + "img/christmashat.6842c19e.png";